import styled from 'styled-components';

import { COLORS, FONTS } from '@r1-frontend/ui-react/assets/js/constants';

export const AddressList = styled.div`
    display: block;
    background: ${COLORS.white};
    border-radius: 16px;
    padding: 40px;
    width: calc(100% - 473px);
    height: 508px;
    overflow: hidden;
    margin-right: 32px;

    &:last-child { 
        margin-right: 0
    }

    @media (max-width: 1024px) {
        width: 100%;
        height: 480px;
        padding: 35px 40px 40px 40px;
    }

    @media (max-width: 760px) {
        height: 807px;
    }

    @media (max-width: 375px) {
        width: 100%;
        height: fit-content;
    }
`;

export const AddressListTitle = styled.div`
    ${FONTS.H3};
    margin-bottom: 24px;
`;

export const AddressBlockWrapper = styled.ul`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    height: 88%;
    justify-content: flex-start;
    max-height: 686px;

    @media (max-width: 535px) {
        max-height: fit-content;
    }
`;

export const AddressBlock = styled.div`
    display: block;
    width: 33.3%;
`;

export const AddressBlockLinks = styled.li`
    display: block;
    list-style-type: none;

    @media (max-width: 1024px) {
        width: 39%;
    }

    @media (max-width: 768px) {
        width: 50%;
    }

    @media (max-width: 375px) {
        width: 100%;
    }
`;

export const AddressBlockKey = styled.div`
    ${FONTS.M};
    font-weight: bold;
    margin-bottom: 8px;
    color: ${COLORS.red};
`;

export const LinkTitle = styled.a`
    ${FONTS.XS};
    display: block;
    font-weight: 600;
    padding: 0;
    width: fit-content;
    margin: 8px 0 8px 0;
    color: ${COLORS.black};
    cursor: pointer;  
    border: none;
    
    @media (max-width: 768px) {
        background: ${COLORS.GRAY_XS};
        padding: 4px 12px;
        border-radius: 100px;
    }
`;
